/** 货机机型。飞机主数据和销售合同航线共用，字面必须一致，出账按这个字符串匹配。 */
export const CARGO_AIRCRAFT_TYPES = ["B747-400F", "B747-400BDSF", "B777F", "A330F"];

export const CARGO_AIRCRAFT_TYPE_OPTIONS = CARGO_AIRCRAFT_TYPES.map((item) => ({
    label: item,
    value: item,
}));
